import { observer } from 'mobx-react-lite';
import { Icon, Step } from 'semantic-ui-react';
import { useStore } from '../../../app/stores/store';
import { useEffect } from 'react';
import StepL4ForOrders from './StepL4ForOrders';
interface Props {
  options: any;
}
function StepL3ForOrders({ options }: Props) {
  const { dashboardStore, commonStore } = useStore();

  useEffect(() => {
    for (let i = 0; i <= options.length; i++) {
      if (
        !commonStore.filterModeTwo?.includes(options?.[i]?.id) &&
        !commonStore.filterModeZero?.includes(options?.[i]?.id)
      ) {
        dashboardStore.openL3ForOrders(options?.[i]?.value);
        break;
      }
    }
    // eslint-disable-next-line
  }, [options]);

  return (
    <div style={{ marginTop: '-10px' }}>
      <Step.Group size="tiny" widths={options.length}>
        {options.map((a: any) =>
          commonStore.filterModeTwo.includes(a.id) ? (
            <></>
          ) : (
            <Step
              className={
                dashboardStore.dashboard.valueForL3Orders === a.value
                  ? 'orderlevel2dark'
                  : 'orderlevel2light'
              }
              style={{
                borderRight: '1px solid #F0F0F0',
                background: `linear-gradient(90deg, rgba(240,240,290,1) ${
                  a.gradientvalue
                }%, rgba(255,255,255,1)${a.gradientvalue + 10}%)`,
              }}
              onClick={() => dashboardStore.openL3ForOrders(a.value)}
              disabled={commonStore.filterModeZero.includes(`${a.id}`)}
            >
              <Icon name={a.Icon} />

              <Step.Content>
                <Step.Title>
                  {a.text} {a.number} 
                </Step.Title>
              </Step.Content>
            </Step>
          ),
        )}
      </Step.Group>
      {
        dashboardStore.dashboard.valueForL3Orders==="Services" ?<StepL4ForOrders/>: null
      }
    </div>
  );
}

export default observer(StepL3ForOrders);
